"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRequestTypes = createRequestTypes;
exports.createRequestStatusMeta = createRequestStatusMeta;
exports.createSuccessNotificationMeta = createSuccessNotificationMeta;
exports.createDangerNotificationMeta = createDangerNotificationMeta;
exports.createRequestActions = createRequestActions;
exports.mapPayloadTo = mapPayloadTo;
exports.encodePropKeys = exports.FAILURE = exports.SUCCESS = exports.REQUEST = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _I18n = _interopRequireDefault(require("I18n"));

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var _utils = require("ReduxMessenger/utils");

var REQUEST = 'REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'FAILURE';
exports.FAILURE = FAILURE;

function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce(function (acc, type) {
    return Object.assign({}, acc, (0, _defineProperty2.default)({}, type, base + "_" + type));
  }, {
    base: base
  });
}

function createRequestStatusMeta(key, requestStatus) {
  return {
    request: {
      key: key,
      status: requestStatus
    }
  };
}

function createSuccessNotificationMeta(message) {
  return {
    notification: (0, _utils.createSuccessNotification)(_I18n.default.text('settingsui.notifications.success'), message, false)
  };
}

function createDangerNotificationMeta(message) {
  return {
    notification: (0, _utils.createDangerNotification)(_I18n.default.text('settingsui.notifications.error'), message, true)
  };
}

var encodePropKeys = function encodePropKeys(props) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return keys.reduce(function (acc, key) {
    return acc + "&" + key + "=" + props[key];
  }, '');
};

exports.encodePropKeys = encodePropKeys;

function createRequestActions(resource) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      keys = _ref.keys,
      _ref$requestMetaCreat = _ref.requestMetaCreator,
      requestMetaCreator = _ref$requestMetaCreat === void 0 ? function (props) {
    return createRequestStatusMeta("" + resource.base + encodePropKeys(props, keys), _RequestStatusTypes.default.PENDING);
  } : _ref$requestMetaCreat,
      _ref$successMetaCreat = _ref.successMetaCreator,
      successMetaCreator = _ref$successMetaCreat === void 0 ? function (response, props) {
    return createRequestStatusMeta("" + resource.base + encodePropKeys(props, keys), _RequestStatusTypes.default.SUCCEEDED);
  } : _ref$successMetaCreat,
      _ref$failureMetaCreat = _ref.failureMetaCreator,
      failureMetaCreator = _ref$failureMetaCreat === void 0 ? function (error, props) {
    return createRequestStatusMeta("" + resource.base + encodePropKeys(props, keys), _RequestStatusTypes.default.FAILED);
  } : _ref$failureMetaCreat;

  return {
    request: (0, _createAction.default)(resource.REQUEST, function (props) {
      return {
        data: props
      };
    }, requestMetaCreator),
    success: (0, _createAction.default)(resource.SUCCESS, function (response, props) {
      return {
        data: response,
        props: props
      };
    }, successMetaCreator),
    failure: (0, _createAction.default)(resource.FAILURE, function (error, props) {
      return {
        error: error,
        props: props
      };
    }, failureMetaCreator)
  };
}

function mapPayloadTo() {
  for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, actionCreatorArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      actionCreatorArgs[_key2] = arguments[_key2];
    }

    return keys.reduce(function (acc, key, idx) {
      return (0, _extends3.default)({}, acc, (0, _defineProperty2.default)({}, key, actionCreatorArgs[idx]));
    }, {});
  };
}